<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const label = computed(() => {
  const value = props.context.label as any
  return value instanceof Function ? value(props.context._value) : value
})
</script>

<template>
  <FormDisclosure
    :lazy="!!context.attrs?.props?.lazy"
    :opened="!!context.attrs?.props?.opened"
    @remove="context.node.emit('remove')"
  >
    <template #button>
      <div class="flex items-center space-x-2">
        <span class="font-medium">{{ label }}</span>
        <div
          v-if="context.state.dirty && !context.state.valid"
          class="i-heroicons-outline-exclamation-circle ml-2 text-red-500"
        />
      </div>
    </template>
    <div class="grid gap-3">
      <slot />
    </div>
  </FormDisclosure>
</template>
